import { useCallback, useEffect, useState } from "react";

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function CountdownCounter() {
  const dateString = "2025-10-15";
  const dateLimit = new Date(dateString);

  let timeLeft: TimeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  const calculateTimeLeft = useCallback(() => {
    const difference = dateLimit.getTime() - new Date().getTime();

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }, [dateLimit]);

  const [time, setTime] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTime(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [calculateTimeLeft]);

  const { days, hours, minutes, seconds } = time;

  return (
    <div className="flex justify-center gap-x-2 text-lg font-bold py-2 rounded-md px-2 w-full">
      <span>{days === 0 ? "0" : days}D</span>
      <span>{hours === 0 ? "0" : hours}H</span>
      <span>{minutes === 0 ? "0" : minutes}M</span>
      <span>{seconds === 0 ? "0" : seconds}S</span>
    </div>
  );
}

export default CountdownCounter;